export default __webpack_public_path__ + "static/media/baton_team_1.4b40d94f.jpg";